import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowRestore } from '@fortawesome/free-solid-svg-icons';

const images = require.context("../../../assets/img/icones/pages", true);
const iconeSearch = images("./search.png");

const Visualizar = ({ id, abrirNovaJanela = false }) => {
  const match = useRouteMatch();
  const url = `${match.url}/${id}`;

  if (abrirNovaJanela) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        <button type="button" className="btn btn-success btn-sm" style={{ marginLeft: "5px" }}>
          <FontAwesomeIcon
            icon={faWindowRestore}
            title="Abrir em uma nova janela"
          />
        </button>
      </a>
    );
  }

  return (
    <Link to={url}>
      <button type="button" className="btn btn-info btn-sm">
        <img src={iconeSearch} alt="" />
      </button>
    </Link>
  );
};

export default Visualizar;
